import React from 'react'

interface DeliveryInfosTextProps {
  isDelivery?: boolean
  city?: string
  uf?: string
  storeName?: string
  pickupPointTime?: {
    openingTime?: string
    closingTime?: string
  }
}
export const DeliveryInfosText = ({
  city,
  isDelivery,
  uf,
  storeName,
  pickupPointTime,
}: DeliveryInfosTextProps) => {
  return (
    <div>
      <span>{isDelivery ? 'Enviar para:' : 'Retirar em:'}</span>
      <p className="delivery-location">
        {isDelivery ? `${city} / ${uf}` : storeName}
      </p>
      <p>
        {!isDelivery &&
          `Retiradas entre ${pickupPointTime?.openingTime}h e ${pickupPointTime?.closingTime}h`}
      </p>
    </div>
  )
}
